import React from "react";
import { useHistory } from "react-router-dom";

import { generatePricingReport, getSettlementHistory } from "apis";
import { Intro } from "components/commons";
import useDataTable from "hooks/useDataTable";
import locale from "localization";

import { settlementHistoryFilterState } from "./settlement-history-filter.state";
import { mapFilterToRequest, mapDataToList } from "./settlement-history.mapper";
import { settlementHistoryColumns } from "./settlement-history-columns";
import SettlementHistoryFilter from "./settlement-history-filter";
import SettlementHistoryList from "./settlement-history.list";
import styles from "./settlement-history.module.scss";
import useCancelSettlement from "./hooks/useCancelSettlement";
import useExport from "hooks/useExport";
import { ConfirmModal } from "components/modals";
import { Path } from "enums";

const SettlementHistoryModule = () => {
  const history = useHistory();
  const cancelSettlement = useCancelSettlement();

  const handleCancelSettlement = ({
    settlementId,
    dealerSettlementStatus,
    discountVoucherStatus,
  }) => {
    cancelSettlement.request({
      settlementId,
      confirmationRequest: () => table.fetch({ newFilterState: filter.mappedFilterState }),
      settlementCollectionRedirection: (settlementId) =>
        history.push(Path.ViewSettlementHistoryById(settlementId)),
      dealerSettlementStatus,
      discountVoucherStatus,
    });
  };

  const { filter, search, table } = useDataTable({
    api: { api: getSettlementHistory },
    filter: { initialState: settlementHistoryFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "settlements",
      mapper: (settlements) =>
        mapDataToList({
          settlements,
          handleCancelSettlement,
          history,
        }),
      columns: settlementHistoryColumns,
    },
  });

  const exportReport = useExport({
    api: generatePricingReport,
    reportType: "settlements",
    mappedFilterState: {
      ...filter.mappedFilterState,
      searchKey: search.searchKey,
      settlementType: "dealer",
    },
  });

  return (
    <>
      <cancelSettlement.ConfirmCancel />
      <ConfirmModal {...cancelSettlement.cancelSettlementErrorModal} />
      <Intro
        title={locale.dealerSettlementHistory}
        subtitle={locale.viewTrackSettlement}
        actionText={locale.update}
        actionOnClick={() => history.push(Path.UpdateSettlement)}
      />
      <SettlementHistoryFilter {...filter} {...search} {...exportReport} />
      <div className={styles.table}>
        <SettlementHistoryList table={table} />
      </div>
    </>
  );
};

export default SettlementHistoryModule;
